import { buildAnnualFeatures } from "../../../../pages/ClientDashboard/SubscriptionPayment/components/mapAnnualPlans";
import { buildPackFeatures } from "../../../../pages/ClientDashboard/SubscriptionPayment/components/mapTopupPacks";

function findById(list, id) {
  return list.find((item) => item._id === id || item.subscriptionKey === id);
}

export function resolveProduct({ type, id, currency, annualPlans = [], topUpPlans = [] }) {
  if (!type || !id) return null;
 
  const isPack = type === "topup";
  const list = isPack ? topUpPlans : annualPlans.filter((p) => !p.isCustomPricing);
  const raw = findById(list, id);
  if (!raw) return null;
 
  const isNGN = currency === "NGN";
  const price = isPack
    ? (isNGN ? raw.priceNGN : raw.priceUSD)
    : (isNGN ? raw.priceNGN : raw.priceUSD);
  const credits = isPack ? raw.creditUnit : raw.creditUnits;
  const perCredit = credits ? price / credits : null;
 
  return {
    id: raw._id,
    name: raw.name,
    credits,
    creditsPerMonth: isPack ? undefined : Math.round(raw.creditUnits / 12),
    price,
    perCredit,
    currency,
    type,
    features: isPack ? buildPackFeatures(raw) : buildAnnualFeatures(raw),
    raw,
  };
}